module.exports = __webpack_public_path__ + "img/Humanisme_01.56fd922d.jpg";